import CryptoJS from 'crypto-js';

const SECRET = process.env.VUE_APP_HASH_KEY;
const OPENSSL_ENCRYPTED_PREFIX = 'U2FsdGVkX1';

function buildStorageKey(key) {
    return CryptoJS.SHA256(key).toString();
}

function isSerializedJson(value) {
    return typeof value === 'string' && ['{', '[', '"'].includes(value.trim().charAt(0));
}

function set(key, value) {
    const encodedKey = buildStorageKey(key);
    const serializedValue = JSON.stringify(value);
    const encodedValue = SECRET
        ? CryptoJS.AES.encrypt(serializedValue, SECRET).toString()
        : serializedValue;

    localStorage.setItem(encodedKey, encodedValue);
}

function get(key) {
    const encodedKey = buildStorageKey(key);
    const encodedValue = localStorage.getItem(encodedKey);

    if (!encodedValue) {
        return;
    }

    if (!SECRET) {
        return encodedValue;
    }

    try {
        const decryptedValue = CryptoJS.AES.decrypt(encodedValue, SECRET).toString(CryptoJS.enc.Utf8);

        if (decryptedValue) {
            return decryptedValue;
        }

        if (isSerializedJson(encodedValue)) {
            return encodedValue;
        }

        if (encodedValue.startsWith(OPENSSL_ENCRYPTED_PREFIX)) {
            return;
        }

        return encodedValue;
    } catch (error) {
        if (isSerializedJson(encodedValue)) {
            return encodedValue;
        }

        return;
    }
}

function remove(key) {
    const encodedKey = buildStorageKey(key);
    localStorage.removeItem(encodedKey);
}

function clear() {
    localStorage.clear();
}

export default {
    set,
    get,
    remove,
    clear
}
